export enum MESSAGES_ADD_DIRECTIONS {
  START = "start",
  END = "end",
  INSIDE = "inside",
}
